/** Agent-owned application messages. Regenerate from the published artifact; never redefine operation bodies here. */
import Ajv from 'ajv/dist/2020.js'
import addFormats from 'ajv-formats'
import artifact from './generated/agent-contract.json' with { type: 'json' }
import type { components } from './generated/agent-contract'

export type WorkspaceOperation = components['schemas']['Request']
type OperationInput = {
  [N in WorkspaceOperation['name']]: Omit<Extract<WorkspaceOperation, { name: N }>, 'op_id'>
}[WorkspaceOperation['name']]

const validator = new Ajv({ strict: false, allErrors: true })
addFormats(validator)
const validate = validator.compile({ $ref: '#/components/schemas/Request', components: artifact.components })

export function validateOperation(operation: WorkspaceOperation): void {
  if (!validate(operation)) throw Error(`Invalid agent operation: ${validator.errorsText(validate.errors)}`)
}

export const op = (operation: OperationInput, opId: string = crypto.randomUUID()): WorkspaceOperation => ({
  op_id: opId,
  ...operation,
})

export type UserMessage = components['schemas']['UserMessage']
export type ContentPart = Exclude<UserMessage['content'], string>[number]
const validateUserMessage = validator.compile({
  $ref: '#/components/schemas/UserMessage',
  components: artifact.components,
})
export const isUserMessage = (value: unknown): value is UserMessage => Boolean(validateUserMessage(value))
export const contentParts = (message: UserMessage): ContentPart[] =>
  typeof message.content === 'string' ? [{ type: 'text', text: message.content }] : message.content
export const messageText = (message: UserMessage) =>
  contentParts(message)
    .filter((part) => part.type === 'text')
    .map((part) => part.text)
    .join('\n')
